<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vbL4Ro/tc-custom/9781634869119.jpg?1718183454092" alt="This image is the cover for the book The Kiss, Hot Flash"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Kiss, Hot Flash
      </h1>
      <p class="bookDescription body article font2">
        <p>Who says love is only for the young and handsome? Everett Peterson and his life partner Charles would beg to disagree. After meeting in 1947, they are now in their twilight years, still together and still very much in love.<br/><br/>However, on this particular night, Everett is agitated. He has discovered Charles lying still on the carpet beside the bed. The nurse on duty at the retirement village has been called. She in turn has called an ambulance. In the anxious moment before help arrives, the nurse tries to calm Everett, but he cannot be pacified. He knows well that at their age, anything could happen. And that thought terrifies him.<br/><br/>Will the ambulance arrive in time? And if not, how will Everett cope with being alone after a life-time with Charles.<br/><br/>Note: This short story was originally published in the charity collection, <i>Love Is Proud</i>.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Wayne Mansfield
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9e706250